/** Default visible columns for Property / Full Portfolio / Multi-Site user lists. */
export const USER_TABLE_DEFAULT_VISIBLE_KEYS = [
  'accepter.username',
  'accepter.job_title',
  'accepter_email',
  'property.length',
  'createdAt',
  'actions',
];

/** Default visible columns when User Role column is included (treeview search). */
export const USER_TABLE_WITH_ROLE_DEFAULT_VISIBLE_KEYS = [
  'accepter.username',
  'accepter.job_title',
  'accepter_email',
  'property.length',
  'accepter_role',
  'createdAt',
  'actions',
];

/** Bump when default columns/order change so persisted prefs reset. */
export const PROPERTY_USER_TABLE_STORAGE_KEY = 'property-user-list-v1';
export const FULL_PORTFOLIO_TABLE_STORAGE_KEY = 'full-portfolio-list-v2';
export const MULTI_SITE_TABLE_STORAGE_KEY = 'multi-site-list-v2';
export const USER_TREEVIEW_TABLE_STORAGE_KEY = 'user-treeview-list-v1';

/** @deprecated Use route-specific keys via getUserTableConfigForRoute */
export const USER_TABLE_STORAGE_KEY = FULL_PORTFOLIO_TABLE_STORAGE_KEY;

const ROUTE_STORAGE_KEYS = {
  property: PROPERTY_USER_TABLE_STORAGE_KEY,
  'full-portfolio': FULL_PORTFOLIO_TABLE_STORAGE_KEY,
  'multi-site': MULTI_SITE_TABLE_STORAGE_KEY,
  treeview: USER_TREEVIEW_TABLE_STORAGE_KEY,
};

export function getUserTableConfigForRoute(route, { showUserRole = false } = {}) {
  return {
    defaultVisibleColumnKeys: showUserRole
      ? USER_TABLE_WITH_ROLE_DEFAULT_VISIBLE_KEYS
      : USER_TABLE_DEFAULT_VISIBLE_KEYS,
    columnVisibilityStorageKey: ROUTE_STORAGE_KEYS[route] || USER_TREEVIEW_TABLE_STORAGE_KEY,
  };
}
